import { render, staticRenderFns } from "./ContentTable.vue?vue&type=template&id=77c932ff&scoped=true"
import script from "./ContentTable.vue?vue&type=script&lang=js"
export * from "./ContentTable.vue?vue&type=script&lang=js"
import style0 from "./ContentTable.vue?vue&type=style&index=0&id=77c932ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c932ff",
  null
  
)

export default component.exports